import { render, staticRenderFns } from "./ControlChat.vue?vue&type=template&id=3cf81e36&scoped=true&"
import script from "./ControlChat.vue?vue&type=script&lang=js&"
export * from "./ControlChat.vue?vue&type=script&lang=js&"
import style0 from "./ControlChat.vue?vue&type=style&index=0&id=3cf81e36&scoped=true&lang=css&"
import style1 from "./ControlChat.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf81e36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VFileInput,VIcon,VSnackbar})
